import { render, staticRenderFns } from "./EnemYearSelection.vue?vue&type=template&id=189d08d3&scoped=true&"
import script from "./EnemYearSelection.vue?vue&type=script&lang=ts&"
export * from "./EnemYearSelection.vue?vue&type=script&lang=ts&"
import style0 from "./EnemYearSelection.vue?vue&type=style&index=0&id=189d08d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d08d3",
  null
  
)

export default component.exports